/*
 * VAKHRA — cart one-of-one treatment
 *
 * Every VAKHRA piece is one of one, so a quantity stepper is meaningless.
 * This replaces the native stepper with a static, accessible "One of one"
 * marker, while leaving the remove control intact.
 *
 * Progressive enhancement. If this script never runs, the native stepper
 * remains and is capped at 1 by inventory anyway, so the cart still works
 * — the stepper is only hidden once this script has set the data-flag that
 * the CSS in vakhra-custom.css §8 keys off, so there is never an empty cell.
 *
 * The cart (page AND drawer) re-renders its rows on every update via
 * component-cart-items.js, which would wipe a one-off DOM edit. A debounced
 * MutationObserver on the body re-applies the treatment after each render;
 * a data-flag guard makes re-processing a no-op so the observer can't loop.
 *
 * Assumption: the entire VAKHRA catalogue is one-of-one, so the treatment
 * applies to every line item without a per-product check. If mixed-stock
 * products are ever added, gate decorate() on a per-row one-of-one flag.
 */
(function () {
  var LABEL = 'One of one';

  function decorate() {
    var controls = document.querySelectorAll(
      '.cart-items__quantity-controls:not([data-vakhra-oneofone])'
    );
    if (!controls.length) return;

    controls.forEach(function (ctrl) {
      var stepper = ctrl.querySelector('quantity-selector, .quantity-selector');
      if (!stepper) return;

      // Remove the native stepper from the accessibility tree. Visual hiding
      // is done in CSS, keyed off the data-flag set below, so hiding and the
      // replacement marker always appear together.
      stepper.setAttribute('hidden', '');

      if (!ctrl.querySelector('.vakhra-cart-oneofone')) {
        var marker = document.createElement('span');
        marker.className = 'vakhra-cart-oneofone';
        marker.textContent = LABEL;
        stepper.insertAdjacentElement('afterend', marker);
      }

      ctrl.dataset.vakhraOneofone = '1';
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      decorate();
    });
  }

  function init() {
    decorate();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
